export class Sort {
    paramName: string;
    direction: string;

    constructor(paramName: string, direction: string){
        this.paramName = paramName;
        this.direction = direction;
    }
}